import { all, select, call, put } from 'redux-saga/effects';
import axios from 'axios';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { getProfileOwner } from '../../selectors/users';
import { getModuleType } from '../../selectors/modules';
import { API_BASE_PATH } from '../../../constants';
import { PapiModuleStreamParams } from '../../../types/papi';
import { setCsrfOnParams } from '.';

export default function* fetchModuleStream(
  action,
  resultsSchema,
  extraParams = {}
) {
  const { streamId } = action;

  const [offset, limit, moduleId, profileOwner] = yield all([
    select(state => withOffset.selectors.getNextOffset(state, streamId)),
    select(state => streamSelectors.getItemsPerFetch(state, streamId)),
    select(state =>
      streamSelectors.getStreamParam(state, streamId, 'moduleId')
    ),
    select(getProfileOwner),
  ]);
  const moduleType = yield select(getModuleType, moduleId);

  let params: PapiModuleStreamParams = {
    username: profileOwner.user.username,
    moduleid: moduleId,
    offset,
    limit,
    ...extraParams,
  };
  params = yield call(setCsrfOnParams, params);
  const response = yield axios
    .get(`${API_BASE_PATH}/module/${moduleType}`, { params })
    .catch(_ => false);

  if (response && response.status === 200) {
    const { hasMore, nextOffset, results } = response.data;
    const { result, entities } = normalize(results, [resultsSchema]);

    yield put(
      withOffset.actions.fetchSuccess({
        streamId,
        hasMore,
        nextOffset,
        items: result,
        entities,
      })
    );
  }

  // TODO error catching
}
